export default __webpack_public_path__ + "static/media/icon.heart.active.16b36576.svg";